import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { FuseConfigService } from "@fuse/services/config.service";
import { fuseAnimations } from "@fuse/animations";
import { AccountService } from "app/shared/services/account/account.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MessageConstant } from "app/shared/utils/message.constant";
import { element } from "protractor";
import { forEach } from "lodash";
import { ClientService } from "app/shared/services/client/client.service";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";

interface ClientCopStationDetails {
    station_id: number;
    station_name: string;
    cpo_id: number;
    cpo_name: string;
    client_id: number;
    client_name: string;
}

@Component({
    selector: "login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    isPasswordFieldType: boolean;
    errorMsg: String;
    splitted: String;
    isErrorMessage = false;
    errorMessage = "";
    isSuccessMessage = false;
    successMessage = "";
    defaultPath: any;
    clientCpoStaDetail: any;
    user_id: number;
    clientCpoStaDet: Array<ClientCopStationDetails>;
    clientlist: any[];
    cpolist: any[];
    stationlist: any[];
    client_id: any;
    clientLocalame: any;
    clientData: any;
    user_role_code: any;
    cpo_login_id: any;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private accountService: AccountService,
        private router: Router,
        private clientService: ClientService,
        private _fuseConfigService: FuseConfigService,
        private snackBar: MatSnackBar,
        private preloader: FuseProgressBarService,
        private _formBuilder: FormBuilder
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true,
                },
                toolbar: {
                    hidden: true,
                },
                footer: {
                    hidden: true,
                },
                sidepanel: {
                    hidden: true,
                },
            },
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        sessionStorage.clear();
        
        if (localStorage.getItem("userDetails")) {
            localStorage.clear();
        }
        if (localStorage.getItem("activeMenuItems")) {
            localStorage.clear();
        }
        this.loginForm = this._formBuilder.group({
            user_name: ["", [Validators.required, Validators.maxLength(50)]],
            password: [
                "",
                [
                    Validators.required,
                    Validators.maxLength(50),
                    Validators.minLength(6),
                ],
            ],
        });
    }
    login() {
        this.preloader.open();
        let formValues = this.loginForm.value;
        let params = {
            user_name: formValues.user_name,
            password: formValues.password,
            project_code: "CMS",
        };

        this.accountService.login(params).subscribe(
            (res: any) => {
                debugger;

                if (res.status != false || res.status != undefined) {
                    if (res.status == true) {
                        if (
                            res.nav_list.length == 0 ||
                            res.nav_list == undefined
                        ) {
                            this.snackBar.open(
                                "You are not authorize for login,please contact administration",
                                "Dismiss",
                                { duration: 5000 }
                            );
                            return;
                        }
                        this.user_id = res.id;
                        this.client_id = res.client_id;
                        this.clientLocalame = res.client_name;
                        let nav_list_without_tab = [];
                        let dataresult = [];
                        this.user_role_code = res.role_code;
                        this.cpo_login_id = res.cpo_id;
                        for (let a of res.nav_list) {
                            this.getNavLevel(a, dataresult);
                        }

                        for (let x of res.nav_list) {
                            let tab = JSON.parse(JSON.stringify(x));
                            this.getNavListWithoutTab(
                                tab,
                                nav_list_without_tab,
                                undefined,
                                undefined
                            );
                        }
                        let userDetails = {
                            userName: params.user_name,
                            userId: res.id,
                            client_id: res.client_id,
                            email: res.email,
                            f_Name: res.f_Name,
                            l_Name: res.l_Name,
                            mobile: res.mobile,
                            token: res.token,
                            project_id: res.project_id,
                            nav_list: nav_list_without_tab,
                            role_id: res.role_id,
                            role_code: res.role_code,
                            role_name: res.role_name,
                            nav_list_with_tab: res.nav_list,
                            cpo_id: res.cpo_id,
                            cpo_name: res.cpo_name,
                        };

                        localStorage.setItem(
                            "userDetails",
                            JSON.stringify(userDetails)
                        );
                        sessionStorage.setItem(
                            "userDetails",
                            JSON.stringify(userDetails)
                        );

                        localStorage.setItem(
                            "navUrlList",
                            JSON.stringify(dataresult)
                        );
                        sessionStorage.setItem(
                            "navUrlList",
                            JSON.stringify(dataresult)
                        );

                        this.defaultPath = JSON.parse(
                            localStorage.getItem("userDetails")
                        );
                        if (this.defaultPath.role_code != "END") {
                            this.getClients(this.user_id);
                        }

                        this.successMessage =
                            MessageConstant.loginSuccessMessage;
                        this.isSuccessMessage = true;
                        setTimeout(() => {
                            //<<<---using ()=> syntax
                            this.isSuccessMessage = false;
                        }, 3000);

                        this.preloader.open();

                        setTimeout(() => {
                            //<<<---using ()=> syntax
                            if (this.defaultPath.nav_list[0].url == null) {
                                let childPath =
                                    this.defaultPath.nav_list[0].children[0]
                                        .url;
                                this.router.navigateByUrl(childPath);
                                this.preloader.close();
                            } else {
                                let defaultMenu =
                                    this.defaultPath.nav_list[0].url;
                                this.router.navigateByUrl(defaultMenu);
                                this.preloader.close();
                            }
                        }, 800);

                        //this.snackBar.open(MessageConstant.loginSuccessMessage, 'Dismiss', { duration: 300 });
                    } else {
                        this.errorMsg = res.message;
                        var index = this.errorMsg.lastIndexOf(" ");
                        this.splitted = this.errorMsg.substring(index + 1);
                        if (this.splitted == formValues.user_name) {
                            this.errorMessage =
                                MessageConstant.loginInvaildUser;
                            this.isErrorMessage = true;
                            setTimeout(() => {
                                this.isErrorMessage = false;
                            }, 3000);
                        } else {
                            this.errorMessage =
                                MessageConstant.loginInvaildPassword;
                            this.isErrorMessage = true;
                            setTimeout(() => {
                                this.isErrorMessage = false;
                            }, 3000);
                        }
                    }
                } else {
                    this.errorMessage = MessageConstant.loginInvaildDetails;
                    this.isErrorMessage = true;
                    setTimeout(() => {
                        this.isErrorMessage = false;
                    }, 3000);
                    //this.snackBar.open(MessageConstant.loginInvaildDetails, 'Dismiss', { duration: 3000 });
                }
            },
            (err) => {
                this.errorMessage = MessageConstant.errorMessage;
                this.isErrorMessage = true;
                setTimeout(() => {
                    this.isErrorMessage = false;
                }, 3000);
                //this.snackBar.open(MessageConstant.errorMessage, 'Dismiss', { duration: 3000 });
            }
        );
    }

    getNavLevel(a: any, dataresult) {
        if (a.url == null) {
            if (a.children != undefined || a.children != null) {
                for (let b of a.children) {
                    this.getNavLevel(b, dataresult);
                }
            }
        } else {
            dataresult.push(a.url);
        }
    }

    getNavListWithoutTab(a: any, nav_list_without_tab, parent, child) {
        if (a.type !== "TAB") {
            let children = [];
            if (parent != undefined && child != undefined) {
                parent.children = child;
            }
            if (a.children != undefined || a.children != null) {
                children = [...a.children];
            }
            a.children = undefined;
            nav_list_without_tab.push(a);
            if (children != undefined || children != null) {
                let child_nav_list_without_tab = [];
                nav_list_without_tab.children = child_nav_list_without_tab;

                for (let b of children) {
                    this.getNavListWithoutTab(
                        b,
                        child_nav_list_without_tab,
                        a,
                        children
                    );
                }
            }
        }
    }

    togglePasswordFieldType() {
        this.isPasswordFieldType = !this.isPasswordFieldType;
    }

    onLoginCpoStationDetailsByClientId(user_id, client_id) {
        let params: any;
        if (this.user_role_code == "CPO") {
            params = {
                cpo_id: this.cpo_login_id,
            };
        } else {
            params = {};
        }

        this.cpolist = [];
        this.stationlist = [];

        this.accountService
            .cpoStationDetailsByClientId(user_id, client_id, params)
            .subscribe(
                (resp: any) => {
                    if (resp.status == true) {
                        this.clientCpoStaDetail = resp.data;
                        localStorage.setItem(
                            "clientCpoStaDetails",
                            JSON.stringify(this.clientCpoStaDetail)
                        );

                        for (
                            var i = 0;
                            i < this.clientCpoStaDetail.cpos.length;
                            i++
                        ) {
                            var cpoList = {
                                cpo_id: this.clientCpoStaDetail.cpos[i].cpo_id,
                                cpo_name:
                                    this.clientCpoStaDetail.cpos[i].cpo_name,
                            };
                            if (
                                !this.cpolist.find(
                                    (c) =>
                                        c.cpo_id ===
                                        this.clientCpoStaDetail.cpos[i].cpo_id
                                )
                            ) {
                                this.cpolist.push(cpoList);
                            }
                        }

                        for (
                            var i = 0;
                            i < this.clientCpoStaDetail.stations.length;
                            i++
                        ) {
                            var stationList = {
                                cpo_id: this.clientCpoStaDetail.stations[i]
                                    .cpo_id,
                                cpo_name:
                                    this.clientCpoStaDetail.stations[i]
                                        .cpo_name,
                                station_id:
                                    this.clientCpoStaDetail.stations[i]
                                        .station_id,
                                station_name:
                                    this.clientCpoStaDetail.stations[i]
                                        .station_name,
                            };
                            if (
                                !this.cpolist.find(
                                    (st) =>
                                        st.station_id ===
                                        this.clientCpoStaDetail.stations[i]
                                            .station_id
                                )
                            ) {
                                this.stationlist.push(stationList);
                            }
                        }
                        localStorage.setItem(
                            "CpoList",
                            JSON.stringify(this.cpolist)
                        );
                        localStorage.setItem(
                            "StationList",
                            JSON.stringify(this.stationlist)
                        );
                    } else {
                        var error = resp.message;
                    }
                },
                (err) => {}
            );
    }

    getClients(user_id) {
        this.clientlist = [];
        this.clientService.getActiveClientsCW(user_id).subscribe(
            (resp: any) => {
                this.clientData = resp;

                for (let x of this.clientData) {
                    // var clientList = {
                    //   client_id: x.client_id,
                    //   client_name: x.client_name
                    // }

                    var clientList = {
                        client_id: x.id,
                        client_name: x.name,
                    };

                    if (
                        !this.clientlist.find(
                            (c) => c.client_id === x.client_id
                        )
                    ) {
                        this.clientlist.push(clientList);
                    }
                }

                localStorage.setItem(
                    "ClientList",
                    JSON.stringify(this.clientlist)
                );

                const toSelect = this.clientlist[0];

                if (this.user_role_code == "CPO") {
                    this.onLoginCpoStationDetailsByClientId(
                        user_id,
                        toSelect.client_id
                    );
                } else if (this.user_role_code == "SA") {
                    this.onLoginCpoStationDetailsByClientId(
                        user_id,
                        this.client_id
                    );
                } else {
                    this.onLoginCpoStationDetailsByClientId(
                        user_id,
                        toSelect.client_id
                    );
                }
            },
            (err) => {}
        );
    }
}
